module.exports = __webpack_public_path__ + "img/economy--.d52fe642.png";